import { withStyles, Grid } from "@material-ui/core";
import React from "react";

const styles = (theme) => ({
    detail:{
        display: "flex",
        alignItems: "center",
        color: theme.dispatchPanelHeaderColor,
        fontSize: theme.textFontSize,
        margin: "15px 0px 15px",
    }
})
const Detail = ({classes, label, value}) => {
    return  (
        <Grid item xs={4} className={classes.detail}>
        {label} <br /> {value}
      </Grid>
    )
}
export default withStyles(styles)(Detail)